import { Component, OnInit, ViewChild, HostListener, Input, AfterViewInit } from '@angular/core';
import { CountryISO, SearchCountryField, TooltipLabel } from 'ngx-intl-tel-input';
import { FormGroup } from '@angular/forms';
import { REGEX_PATTERNS } from 'src/app/core/constants/regex-patterns.constant';

@Component({
  selector: 'app-phone-number',
  templateUrl: './phone-number.component.html',
  styleUrls: ['./phone-number.component.scss']
})
export class PhoneNumberComponent implements OnInit, AfterViewInit {
  separateDialCode = true;
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  phoneNumberPlaceholder = 'Phone number';
  preferredCountries: CountryISO[] = [CountryISO.UnitedStates];
  TooltipLabel = TooltipLabel;
  @Input() public isparentFormSubmitted;
  @Input() public parentForm: FormGroup;
  @Input() public selectedCountryISO;
  @Input() public onlyCountries;
  @Input() public searchCountryFlag;
  @ViewChild('ngxintltelinput', { static: false }) ngxintltelinput: any;
  @ViewChild('ngxintltelinputDiv', { static: false }) ngxintltelinputDiv: any;

  constructor() { }

  ngOnInit() {
    if(this.parentForm.controls.phone.value && this.parentForm.controls.phone.value.number){
      this.parentForm.get('phone').setValue(this.parentForm.controls.phone.value.number)
    }

    if (!this.selectedCountryISO) {
      this.selectedCountryISO = CountryISO.UnitedStates;
    }
    if(!this.onlyCountries){
      this.onlyCountries = [];
    }else{
      this.preferredCountries = [];
    }
    if(this.searchCountryFlag == undefined){
      this.searchCountryFlag = true;
    }
  }

  ngAfterViewInit() {
    if (this.ngxintltelinputDiv.nativeElement.querySelector('#phone_number')) {
      this.ngxintltelinputDiv.nativeElement.querySelector('#phone_number').setAttribute("placeholder", this.phoneNumberPlaceholder);
    }

  }
  counryChanged(country) {
    if (this.ngxintltelinputDiv.nativeElement.querySelector('#phone_number')) {
      // console.log("Here");
      setTimeout(()=>{
        this.ngxintltelinputDiv.nativeElement.querySelector('#phone_number').setAttribute("placeholder", this.phoneNumberPlaceholder);
      },100);
      
    }
  }
  /**
	 * Search country based on country name, iso2, dialCode or all of them.
	 */
  searchCountry(event) {
    if (event.keyCode == 13 || !this.ngxintltelinput.countryList) {
      event.preventDefault();
      return;
    }

    if (event.keyCode != 38 && event.keyCode != 40 && this.ngxintltelinput && this.ngxintltelinput.countryList && this.ngxintltelinput.countryList.nativeElement.querySelector('.country.focus')) {
      this.ngxintltelinput.countryList.nativeElement.querySelector('.country.focus').classList.remove("focus");
    }
    if (!this.ngxintltelinput.countrySearchText && this.ngxintltelinput.countryList) {
      this.scrollTop();
      let ax = this.ngxintltelinput.countryList.nativeElement.querySelector('.country#us');
      if (ax) {
        ax.scrollIntoView({ block: "nearest" });
      }
      // this.countryList.nativeElement.querySelector('li').scrollIntoView({ behavior: 'smooth' });
      return;
    }

    const countrySearchTextLower = this.ngxintltelinput.countrySearchText.toLowerCase();
    const country = this.ngxintltelinput.allCountries.filter(c => {
      if (this.ngxintltelinput.searchCountryField.indexOf(SearchCountryField.All) > -1) {
        // Search in all fields
        if (c.iso2.toLowerCase().startsWith(countrySearchTextLower)) {
          return c;
        }
        if (c.name.toLowerCase().startsWith(countrySearchTextLower)) {
          return c;
        }
        if (c.dialCode.startsWith(this.ngxintltelinput.countrySearchText)) {
          return c;
        }
      } else {
        // Or search by specific SearchCountryField(s)
        if (this.ngxintltelinput.searchCountryField.indexOf(SearchCountryField.Iso2) > -1) {
          if (c.iso2.toLowerCase().startsWith(countrySearchTextLower)) {
            return c;
          }
        }
        if (this.ngxintltelinput.searchCountryField.indexOf(SearchCountryField.Name) > -1) {
          if (c.name.toLowerCase().startsWith(countrySearchTextLower)) {
            return c;
          }
        }
        if (this.ngxintltelinput.searchCountryField.indexOf(SearchCountryField.DialCode) > -1) {
          if (c.dialCode.startsWith(this.ngxintltelinput.countrySearchText)) {
            return c;
          }
        }
      }
    });

    if (country.length > 0) {
      const el = this.ngxintltelinput.countryList.nativeElement.querySelector('#' + country[0].iso2);
      if (el) {
        if (!this.ngxintltelinput.countryList.nativeElement.querySelector('.country.focus')) {
          el.classList.add('focus');
        }
        if (event.keyCode != 38 && event.keyCode != 40) {
          this.scrollTop();
          el.scrollIntoView({ block: 'nearest' });
        }
      }
    }

    this.checkSeparateDialCodeStyle();
    return;
  }

  /**
   * Scrolling to end of page bug fix
   *
   * @private
   * @memberof PhoneNumberComponent
   */
  private checkSeparateDialCodeStyle() {
    if (this.separateDialCode && this.ngxintltelinput.selectedCountry) {
      var cntryCd = this.ngxintltelinput.selectedCountry.dialCode;
      this.ngxintltelinput.separateDialCodeClass = 'separate-dial-code iti-sdc-' + (cntryCd.length + 1);
    } else {
      this.ngxintltelinput.separateDialCodeClass = '';
    }
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.keyCode === 13 && this.ngxintltelinput.countryList && this.ngxintltelinput.countryList.nativeElement.querySelector('.country.focus')) {
      this.ngxintltelinput.countryList.nativeElement.querySelector('.country.focus').click();
      this.ngxintltelinput.countryList.nativeElement.querySelector('.country.focus').classList.remove("focus");
      return;
    }
    if ([38, 40].includes(event.keyCode) && document.querySelector('.flag-container.show')) {
      event.preventDefault();
      if (this.ngxintltelinputDiv.nativeElement.querySelector('input') == document.activeElement) {
        this.ngxintltelinputDiv.nativeElement.querySelector('input').blur();
      }
      // document.getElementsByTagName('body')[0].style.overflow = 'hidden';
      if (!this.ngxintltelinput.countryList.nativeElement.querySelector('.country.focus')) {
        this.ngxintltelinput.countryList.nativeElement.querySelector('.country').classList.add("focus");
      } else {
        let element = this.ngxintltelinput.countryList.nativeElement.querySelector('.country.focus');

        element.classList.remove("focus");
        if (event.keyCode == 40 && element.nextSibling) {
          while (!element.nextSibling.classList || !element.nextSibling.classList.contains('country')) {
            element = element.nextSibling;
          }
          element.nextSibling.classList.add('focus');
          element.nextSibling.scrollIntoView({ block: "nearest" });
        } else if (event.keyCode == 38 && element.previousSibling) {
          while (!element.previousSibling.classList || !element.previousSibling.classList.contains('country')) {
            element = element.previousSibling;
            if (!element.previousSibling) {
              break;
            }
          }
          if (element.previousSibling != null) {
            element.previousSibling.classList.add('focus');
            element.previousSibling.scrollIntoView({ block: "nearest" });
          }
        }
      }
    }
  }

  scrollTop() {
    if (this.ngxintltelinput.countryList) {
      let ax = this.ngxintltelinput.countryList.nativeElement.querySelector('.country#ax');
      if (ax) {
        ax.scrollIntoView({ block: "nearest" });
      }
    }

  }
  inputClick(e){
    if(this.ngxintltelinputDiv.nativeElement && this.ngxintltelinputDiv.nativeElement.querySelector('#country-search-box')){
      this.ngxintltelinputDiv.nativeElement.querySelector('#country-search-box').setAttribute('autocomplete','off');
    }
  }

}
